
/* eslint-disable no-return-await */

import moment from 'moment'
import Util from '@/assets/libs/util'
import CartController from '@/assets/controllers/CartController'
import LocaleController from '@/assets/controllers/LocaleController'
import PrinterParameters from '@/assets/libs/PrinterParameters'
import requesModule from '@/assets/libs/requestModule'
import CashbackCampaingController from './CashbackCampaingController'
import IdentifiedConsumerController from './IdentifiedConsumerController'

const EVENT_PRINT = '/print'

// Busca as configurações parametrizadas para a impressora
const getPrinterInfo = () => {
    return {
        printerType: Util.getLocalConfigs('modeloImpressora'),
        kioskPort: Util.getLocalConfigs('kioskPort'),
        port: Util.getLocalConfigs('portaImpressora')
    }
}

// Envia um conjunto de comandos para a impressora realizar a impressao dos dados
const sendPrint = async (printerInfo, printerCommands, testURLPerifericos = null) => {
    return await requesModule.curlRequest(
        EVENT_PRINT,
        {
            printerInfo: printerInfo,
            commands: printerCommands
        },
        testURLPerifericos
    ).then(r => r)
}

const buildPrintOnScreenText = (printerCommands, printerParameters) => {
    let text = ''
    printerCommands.forEach(command => {
        if (command && command.parameters && command.parameters.text) {
            text += command.parameters.text.replace(printerParameters.comandoEnter, '\n')
        }
    })
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

// Cria uma linha tracejada respeitando a largura específica do papel da impressora em uso
const printLine = (printerParameters) => {
    let line = ''
    for (let i = 0; i < printerParameters.largura; i++) {
        line += '-'
    }
    line += printerParameters.comandoEnter
    return line
}

// Centraliza o texto de acordo com a largura específica do papel da impressora em uso
const centralizeText = (text, printerParameters) => {
    let textSize = text.length
    let lineSize = printerParameters.largura
    let leftSpaces = (lineSize - textSize) / 2
    let centralizedText = ''

    for (let i = 0; i < leftSpaces; i++) {
        centralizedText += ' '
    }
    centralizedText += text
    return centralizedText
}
const addEmptyLine = (printerParameters) => {
    let currentLine = ''
    let largura = printerParameters.largura
    for (let i = 0; i < largura; i++) {
        currentLine += ' '
    }
    return currentLine
}

// Formata o texto recebido, retornando a mesma String com as quebras de linha adequadas ao tamanho de papel da impressora
const addLineBreaks = (text, printerParameters, centralize = false) => {
    let words = text.split(' ')
    let returnStr = ''
    let currentLine = ''

    words.forEach((word, index) => {
        if ((currentLine + ' ' + word).length < printerParameters.largura) {
            if (index === 0) {
                currentLine += word
            } else {
                currentLine += ' ' + word
            }
        } else {
            if (centralize) {
                currentLine = centralizeText(currentLine, printerParameters)
            }
            currentLine += printerParameters.comandoEnter
            returnStr += currentLine
            currentLine = word
        }
    })

    if (centralize) {
        currentLine = centralizeText(currentLine, printerParameters)
    }
    returnStr += currentLine + printerParameters.comandoEnter
    return returnStr
}

const justifyText = (string1, string2, printerParameters) => {
    let textSize = (string1 + string2).length
    let blankSpaces = (printerParameters.largura - textSize) - 1
    let returnStr = ''

    returnStr += string1
    for (let i = 0; i < blankSpaces; i++) {
        returnStr += ' '
    }
    returnStr += string2 + printerParameters.comandoEnter
    return returnStr
}

const formatCounter = (counter) => {
    if (counter < 10) {
        return '00' + counter
    } else if (counter < 100) {
        return '0' + counter
    } else {
        return '' + counter
    }
}

const formatBigNumber = (bigNumber) => {
    // Se este valor chegar do XML em formato de número e não de String, força a conversão
    bigNumber = '' + bigNumber

    let fragmentSize = 4
    let indexStart = 0
    let indexEnd = 4
    let fragment = ''
    let formattedBigNumber = ''
    do {
        fragment = bigNumber.substring(indexStart, indexEnd)
        formattedBigNumber += fragment + ' '
        indexStart += fragmentSize
        indexEnd += fragmentSize
    } while (indexStart < bigNumber.length)

    return formattedBigNumber
}

// Formata o número para ser exibido com duas casas decimais e utilizando "," para separar a parte inteira da decimal
const formatFloat = (value) => {
    if (typeof value !== 'string') {
        value = '' + value
    }
    let formattedFloat = parseFloat(value).toFixed(2)
    formattedFloat = formattedFloat.replace('.', ',')
    return formattedFloat
}

const formatTime = (time) => {
    if (typeof time !== 'string') {
        time = '' + time
    }

    let day = ''
    let month = ''
    let year = ''
    let hour = ''
    let minute = ''
    let second = ''

    if (time.length > 14) {
        day = time.substring(8, 10)
        month = time.substring(5, 7)
        year = time.substring(0, 4)
        hour = time.substring(11, 13)
        minute = time.substring(14, 16)
        second = time.substring(17, 19)
    } else {
        day = time.substring(6, 8)
        month = time.substring(4, 6)
        year = time.substring(0, 4)
        hour = time.substring(8, 10)
        minute = time.substring(10, 12)
        second = time.substring(12, 14)
    }

    let formattedTime = day + '/' + month + '/' + year + ' ' + hour + ':' + minute + ':' + second
    return formattedTime
}

const formatDocumentString = (docNumber) => {
    docNumber = String(docNumber).toUpperCase()
    let formattedDocStr = ''

    if (docNumber.length === 11) {
        // Formata como CPF
        formattedDocStr += 'CPF CONSUMIDOR: '
        formattedDocStr += docNumber.substring(0, 3) + '.' + docNumber.substring(3, 6) + '.' +
        docNumber.substring(6, 9) + '-' + docNumber.substring(9, 11)
    } else {
        // Formata como CNPJ
        formattedDocStr += 'CNPJ CONSUMIDOR: '
        formattedDocStr += docNumber.substring(0, 2) + '.' + docNumber.substring(2, 5) + '.' +
        docNumber.substring(5, 8) + '/' + docNumber.substring(8, 12) + '-' + docNumber.substring(12, 14)
    }
    return formattedDocStr
}

const buildCouponHeader = (printerParameters) => {
    let text = ''
    text += printLine(printerParameters)
    text += centralizeText('PEDIDO', printerParameters) + printerParameters.comandoEnter
    text += centralizeText('DATA: ' + moment().format('DD/MM/YYYY HH:mm:ss'), printerParameters) + printerParameters.comandoEnter
    text += printLine(printerParameters)
    text += 'ORIGEM: TERMINAL DE AUTO ATENDIMENTO' + printerParameters.comandoEnter

    let nomeDoDispositivo = Util.getLocalConfigs('nomeDoDispositivo')
    text += addLineBreaks('GARCON: --  - ' + nomeDoDispositivo, printerParameters, false)

    text += printLine(printerParameters)
    // text += printerParameters.comandoEnter
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildCouponFooter = (printerParameters, saleData, hasToPrintFiscal = true) => {
    let text = ''
    // let senha = saleData.pagerId ? saleData.pagerId : ''
    text += printLine(printerParameters)
    /*
    if (senha !== '') {
        /* text += centralizeText('SENHA ' + senha, printerParameters) + printerParameters.comandoEnter
        text += printLine(printerParameters)
        text += buildPagerId(printerParameters, saleData)
    }
    */
    let isCashPayment = false

    try {
        isCashPayment = Object.keys(saleData).length === 1
    } catch (error) {
        console.log('Erro ao tentar determinar se a venda foi realizada a dinheiro - impressão de cupom')
    }

    if (isCashPayment) {
        text += addLineBreaks('POR FAVOR, DIRIJA-SE AO CAIXA PARA EFETUAR O PAGAMENTO', printerParameters, true)
        text += printLine(printerParameters)
    }

    if (saleData.urlPager && !hasToPrintFiscal) {
        text += printerParameters.comandoEnter + printerParameters.comandoEnter + printerParameters.comandoEnter
    } else {
        text += printerParameters.comandoEnter + printerParameters.comandoEnter
    }
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildFiscalHeader = (printerParameters, nota, saleData) => {
    let data = nota.infNFe ? nota.infNFe : nota.infCFe
    let text = ''

    let address = ''
    address += data.emit.xNome
    address += ' CNPJ: ' + data.emit.CNPJ
    address += ' ' + data.emit.enderEmit.xLgr + ', '
    address += ' ' + data.emit.enderEmit.nro + ', '
    address += ' ' + data.emit.enderEmit.xBairro + ', '
    address += ' ' + data.emit.enderEmit.xMun
    let uf = data.emit.enderEmit.UF ? data.emit.enderEmit.UF : ''
    if (uf.length > 0) {
        address += ' - ' + uf
    }

    text += addLineBreaks(address, printerParameters, true)
    text += printLine(printerParameters)

    // Notas do tipo SAT
    if (nota.infCFe) {
        text += addLineBreaks('Extrato N ' + saleData.nfceCode, printerParameters, true)
        text += addLineBreaks('CUPOM FISCAL ELETRONICO - SAT', printerParameters, true)
    } else {
        text += addLineBreaks('DOCUMENTO AUXILIAR DA NOTA FISCAL DE CONSUMIDOR ELETRONICA', printerParameters, true)
    }

    text += printLine(printerParameters)
    // text += addLineBreaks('Item | Codigo | Descricao | Qtde | UN | Vl.Unit | Vl.Tot', printerParameters, true)
    text += addLineBreaks('Item | Descricao | Qtde | UN | Vl.Unit | Vl.Tot', printerParameters, true)
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildFiscalBody = (printerParameters, nota, protNfe, saleData, paymentMethod, balanceFamily) => {
    let data = {}
    let infoSupl = {}
    if (nota.infNFe) {
        data = nota.infNFe
        infoSupl = nota.infNFeSupl
    } else {
        data = nota.infCFe
    }
    let text = ''
    let counter = 0
    let products = []

    // Se a lista de produtos da Nota Fiscal contiver apenas um item, ela não chegará como array, fazendo o forEach
    // quebrar. Esse bloco garante que os produtos cheguem ao forEach como um array
    let nfeProducts = data.det
    if (Array.isArray(nfeProducts)) {
        products = nfeProducts
    } else {
        products.push(nfeProducts)
    }

    let printed = false
    if (Util.getLocalConfigs('agruparnaimpressao') === true) {
        let groupedText = ''

        try {
            const validProd = products.filter(p => p && p.prod && p.prod.cProd)
            const codProdList = [...new Set(products.map(p => p.prod.cProd))]

            codProdList.forEach(pCode => {
                const curProdList = validProd.filter(p => p.prod.cProd === pCode)

                const totalQnt = curProdList.reduce((acc, p) => { // Regra de soma qntd
                    const qnt = (p.prod && p.prod.qCom) ? parseFloat(p.prod.qCom) : 0
                    return acc + qnt
                }, 0)

                const totalValue = curProdList.reduce((acc, p) => { // Regra de soma valor total dos produtos
                    const valor = (p.prod && p.prod.vProd) ? parseFloat(p.prod.vProd) : 0
                    return acc + valor
                }, 0)

                const curProd = curProdList[0].prod

                counter++
                let lineText = formatCounter(counter) + ' '
                lineText += curProd.xProd + ' '
                lineText += formatFloat(totalQnt) + ' '
                lineText += curProd.uCom + ' '
                lineText += formatFloat(curProd.vUnCom) + ' '
                lineText += formatFloat(totalValue) + ' '
                // groupedText += addLineBreaks(lineText, printerParameters) + printerParameters.comandoEnter
                groupedText += addLineBreaks(lineText, printerParameters)
            })
            text += groupedText
            printed = true
        } catch (error) {
            console.log('Erro no agrupamento:', error)
            printed = false
        }
    }

    if (!printed) {
        products.forEach(product => {
            counter++
            let lineText = formatCounter(counter) + ' '
            // lineText += product.prod.cProd + ' '
            lineText += product.prod.xProd + ' '
            lineText += formatFloat(product.prod.qCom) + ' '
            lineText += product.prod.uCom + ' '
            lineText += formatFloat(product.prod.vUnCom) + ' '
            lineText += formatFloat(product.prod.vProd) + ' '
            // text += addLineBreaks(lineText, printerParameters) + printerParameters.comandoEnter
            text += addLineBreaks(lineText, printerParameters)
        })
    }

    text += printLine(printerParameters)
    text += justifyText('QTDE. TOTAL DE ITENS ', counter, printerParameters)
    let formattedTotalValue = data.pag ? data.pag.detPag.vPag : data.pgto.MP.vMP
    let validationNumber = typeof formattedTotalValue === 'string' ? parseFloat(formattedTotalValue.replace(',', '.')) : null

    if (isNaN(validationNumber) || validationNumber === null) {
        try {
            let valuesArray = data.pag ? data.pag.detPag : data.pgto.MP
            let totalValue = 0
            if (valuesArray && valuesArray[0] && valuesArray[0].vPag) {
                valuesArray.forEach(element => {
                    totalValue = Math.round((parseFloat(totalValue) + parseFloat(element.vPag)) * 100) / 100
                })
            } else if (valuesArray && valuesArray[0] && valuesArray[0].vMP) {
                valuesArray.forEach(element => {
                    totalValue = Math.round((parseFloat(totalValue) + parseFloat(element.vMP)) * 100) / 100
                })
            }
            formattedTotalValue = totalValue
        } catch (error) {
            let message = 'Houve um erro ao calcular os pagamentos recebidos no array durante a impressao da nota fiscal'
            console.log(message)
            Util.logComunication('PrinterController Exception ', {}, message + JSON.stringify(error))
        }
    }
    // let totalCampaignCashbackDiscount = saleData.CRMDiscount
    let totalCampaignCashbackDiscount = CashbackCampaingController.getDiscountApplied()

    let totalValueWithDiscount = Math.round((parseFloat(formattedTotalValue) + parseFloat(totalCampaignCashbackDiscount.value)) * 100) / 100
    let formattedTotalDiscount = formatFloat(totalCampaignCashbackDiscount.value)
    let formattedTotalValueWithDiscount = formatFloat(totalValueWithDiscount)
    formattedTotalValue = formatFloat(formattedTotalValue)
    text += justifyText('VALOR TOTAL R$ ', totalCampaignCashbackDiscount.value ? formattedTotalValueWithDiscount : formattedTotalValue, printerParameters)
    text += justifyText('VALOR A PAGAR R$ ', formattedTotalValue, printerParameters)
    text += justifyText('VALOR PAGO R$ ', formattedTotalValue, printerParameters)
    if (totalCampaignCashbackDiscount.value && totalCampaignCashbackDiscount.campaignEnabled === 1) {
        text += justifyText('DESCONTO CRM&BONUS R$ ', formattedTotalDiscount, printerParameters)
    }

    if (totalCampaignCashbackDiscount.value && ([2, 3, 4].includes(totalCampaignCashbackDiscount.campaignEnabled))) {
        text += justifyText('DESCONTOS R$ ', formattedTotalDiscount, printerParameters)
    }
    text += justifyText('FORMA PAGAMENTO ', paymentMethod.NMTIPORECE, printerParameters)

    // Esse bloco não é impresso nas notas de tipo SAT
    if (!nota.infCFe) {
        text += printLine(printerParameters)
        text += addLineBreaks('Consulte pela Chave de Acesso em', printerParameters, true)
        let infoSuplIsEmpty = Object.keys(infoSupl).length === 0
        let urlChave = !infoSuplIsEmpty ? infoSupl.urlChave : ''
        // text += addLineBreaks(urlChave, printerParameters, true) + printerParameters.comandoEnter
        text += addLineBreaks(urlChave, printerParameters, true)
        if (saleData && saleData.nfceAccessCode) {
            let bigNumber = formatBigNumber(saleData.nfceAccessCode)
            text += addLineBreaks(bigNumber, printerParameters, true)
        }
    }

    text += printLine(printerParameters)

    let consumerCNPJ = ''
    let consumerCPF = ''

    try {
        consumerCNPJ = data.dest.CNPJ
    } catch (error) {
        console.log('Não foi possível ler o número do CNPJ a partir do XML da Nota Fiscal')
    }

    try {
        consumerCPF = data.dest.CPF
    } catch (error) {
        console.log('Não foi possível ler o número do CPF a partir do XML da Nota Fiscal')
    }

    if (consumerCNPJ) {
        let CNPJStr = formatDocumentString(consumerCNPJ, printerParameters)
        text += addLineBreaks(CNPJStr, printerParameters, true)
    } else if (consumerCPF) {
        let CPFStr = formatDocumentString(consumerCPF, printerParameters)
        text += addLineBreaks(CPFStr, printerParameters, true)
    } else {
        text += addLineBreaks('CONSUMIDOR NAO IDENTIFICADO', printerParameters, true)
    }

    text += printLine(printerParameters)
    saleData.dtEmit = ''
    if (nota.infCFe) { // Notas do tipo SAT
        let formattedSatNumber = data.ide.nserieSAT.substring(0, 3) + ' ' + data.ide.nserieSAT.substring(3, 6) + ' ' + data.ide.nserieSAT.substring(6)
        text += addLineBreaks('SAT No ' + formattedSatNumber, printerParameters, true)
        let formattedDtEmi = data.ide.dhEmi ? formatTime(data.ide.dhEmi) : formatTime(data.ide.dEmi + data.ide.hEmi)
        saleData.dtEmit = formattedDtEmi
        text += addLineBreaks(formattedDtEmi, printerParameters, true)
        // text += addLineBreaks(saleData.nfceAccessCode, printerParameters, true) + printerParameters.comandoEnter
        text += addLineBreaks(saleData.nfceAccessCode, printerParameters, true)
    } else { // Notas que não são SAT
        // text += addLineBreaks('Numero ' + nfe.infNFe.ide.cNF + ' Serie ' + nfe.infNFe.ide.serie, printerParameters, true)
        let numeroNota = saleData.nfceCode
        text += addLineBreaks('Numero ' + numeroNota, printerParameters, true)
        let formattedDtEmi = data.ide.dhEmi ? formatTime(data.ide.dhEmi) : formatTime(data.ide.dEmi + data.ide.hEmi)
        saleData.dtEmit = formattedDtEmi
        // text += addLineBreaks('Emissao ' + formattedDtEmi + ' - Via Consumidor', printerParameters, true) + printerParameters.comandoEnter
        text += addLineBreaks('Emissao ' + formattedDtEmi + ' - Via Consumidor', printerParameters, true)
    }

    if (protNfe !== '') {
        text += addLineBreaks('Protocolo de Autorizacao ' + protNfe.infProt.nProt, printerParameters, true)
        let formattedDtRecbto = formatTime(protNfe.infProt.dhRecbto)
        text += addLineBreaks('Data de Autorizacao ' + formattedDtRecbto, printerParameters, true)
    } else if (data.infAdic) {
        try {
            let info = data.infAdic.infCpl ? data.infAdic.infCpl : data.infAdic.obsFisco.xTexto
            text += addLineBreaks(info, printerParameters, true)
        } catch (error) {
            console.log('Não foi possível ler o campo info (infCpl ou obsFisco.xTexto) a partir do XML da Nota Fiscal')
        }
    }

    text += printLine(printerParameters)

    const paymentID = paymentMethod.IDTIPORECE || ''
    if (IdentifiedConsumerController.userIsLogged() && ['9', 'A'].includes(paymentID)) {
        const consumerData = IdentifiedConsumerController.getConsumerData()
        let saldoCons = saleData.consumerDebit || null
        let saldoCred = saleData.personalCredit || null

        text += justifyText('CLIENTE: ', consumerData.clientCode + ' - ' + consumerData.clientName, printerParameters)
        text += justifyText('CONSUMIDOR: ', consumerData.consumerCode, printerParameters)
        text += justifyText('NOME: ', consumerData.consumerName, printerParameters)

        if (paymentID === 'A' && saldoCons !== null) {
            // saldoCons = Util.formatMoney(saldoCons)
            text += justifyText('SALDO TOTAL: ', 'R$ ' + saldoCons, printerParameters)
        }
        if (paymentID === '9') {
            if (balanceFamily && balanceFamily.length > 0) {
                balanceFamily.forEach(e => {
                    let balance = e.balance ? Util.formatMoney(e.balance) : Util.formatMoney(0)
                    text += justifyText('SALDO FAMILIA ' + e.familyName + ': ', balance, printerParameters)
                })
            } else if (saldoCred !== null) {
                // saldoCred = Util.formatMoney(saldoCred)
                text += justifyText('SALDO TOTAL: ', 'R$ ' + saldoCred, printerParameters)
            }
        }

        text += printLine(printerParameters)
    }
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildFiscalFooter = (printerParameters, nota, saleData, paymentNumber, printOnScreen, tapReprintComandas, bonusResume) => {
    let text = ''

    if (!printOnScreen) {
        // text += printerParameters.comandoEnter
        text += printLine(printerParameters)
    }

    if (saleData && saleData.approximateTaxes) {
        let cityTax = saleData.approximateTaxes.cityTax ? saleData.approximateTaxes.cityTax : 0
        let stateTax = saleData.approximateTaxes.stateTax ? saleData.approximateTaxes.stateTax : 0
        let federalTax = saleData.approximateTaxes.federalTax ? saleData.approximateTaxes.federalTax : 0
        let formattedcity = formatFloat(cityTax)
        let formattedstate = formatFloat(stateTax)
        let formattedfederal = formatFloat(federalTax)

        text += addLineBreaks(' Trib aprox R$ ' + formattedfederal + ' Federal, R$ ' + formattedstate + ' Estadual R$ ' + formattedcity + ' Municipal', printerParameters, true)
        text += addLineBreaks(' (Conforme Lei Fed. 12.741/2012) - Fonte: IBPT', printerParameters, true)
        text += printLine(printerParameters)
    } else {
        let data = nota.infNFe ? nota.infNFe : nota.infCFe

        text += addLineBreaks('Informacao dos Tributos Totais Incidentes', printerParameters, true)
        let value = data.total.ICMSTot.vTotTrib ? data.total.ICMSTot.vTotTrib : data.total.vCFeLei12741
        let formattedValue = formatFloat(value)
        text += addLineBreaks('(Lei Federal 12.741/2012) R$ ' + formattedValue, printerParameters, true)
        text += printLine(printerParameters)
    }

    text += addLineBreaks('Teknisa Software - www.teknisa.com', printerParameters, true)
    text += addLineBreaks(`TAA - ${process.env.VERSION}`, printerParameters, true)
    if (bonusResume && bonusResume.totalBalance && bonusResume.campaignEnabled === 1) {
        text += printLine(printerParameters)
        let formattedBalance = formatFloat(bonusResume.totalBalance)
        text += addLineBreaks('SALDO ATUALIZADO CRM&BONUS: R$ ' + formattedBalance, printerParameters)
        text += printLine(printerParameters)
    }
    if (bonusResume && bonusResume.totalBalance && bonusResume.campaignEnabled === 2) {
        text += printLine(printerParameters)
        let formattedBalance = formatFloat(bonusResume.totalBalance)
        let formattedGeneretedBalance = formatFloat(bonusResume.generatedBalance)
        let formattedUsedBonus = formatFloat(bonusResume.redeemBalance)
        let formatedDataBonus = bonusResume.expiration
        if (formattedUsedBonus) {
            text += addLineBreaks(`VOCE USOU: R$ ${formattedUsedBonus} DE CASHBACK`, printerParameters)
        }
        if (formattedGeneretedBalance) {
            text += addLineBreaks('VOCE GANHOU: R$ ' + formattedGeneretedBalance + ' VALIDO ATE ' + formatedDataBonus, printerParameters)
        }
        if (formattedBalance) {
            text += addLineBreaks('SALDO TOTAL DE CASHBACK: R$ ' + formattedBalance, printerParameters)
        }
        text += addLineBreaks('PREENCHA A PESQUISA E GANHE UM PREMIO NA PROXIMA COMPRA', printerParameters)
        text += printLine(printerParameters)
    }
    if (bonusResume && bonusResume.totalBalance && bonusResume.campaignEnabled === 3) {
        text += printLine(printerParameters)
        let formattedBalance = formatFloat(bonusResume.totalBalance)
        text += addLineBreaks('SALDO TOTAL DE CASHBACK: R$ ' + formattedBalance, printerParameters)
        text += printLine(printerParameters)
    }
    /* Olga Tech verificar o que deve ser impresso aqui */
    if (saleData.pagerId !== '') {
        // text += printLine(printerParameters)
        text += buildPagerId(printerParameters, saleData)
        // text += centralizeText(`SENHA ${saleData.pagerId}`, printerParameters) + printerParameters.comandoEnter
        // text += printLine(printerParameters)
    }
    /* if (paymentNumber !== '') {
            text += addLineBreaks(`NSU ${paymentNumber}`, printerParameters)
        }
        text += addLineBreaks('Filial: ' + saleData.subsidiaryCode + ' ' + saleData.subsidiaryName, printerParameters)
        text += addLineBreaks('Loja: ' + saleData.storeCode + ' ' + saleData.storeName, printerParameters)
        text += addLineBreaks('Caixa: ' + saleData.posCode + ' ' + saleData.posName, printerParameters) + printerParameters.comandoEnter

        const CA = CartController.getComandasAgregadas()
        if (CA && CA.length > 0) {
            let comandas = CA.map(c => c.saleDescription).join()
            text += addLineBreaks('Comanda(s): ' + comandas, printerParameters)
        } else if (Util.isTapMode() && tapReprintComandas) {
            text += addLineBreaks('Comanda(s): ' + tapReprintComandas, printerParameters)
        }

        if (saleData.couponFooter) {
            text += centralizeText(saleData.couponFooter, printerParameters)
        }

        // O Totem Gertec já adiciona uma margem grande automaticamente
        if (!Util.isGertecSk210()) {
            text += printerParameters.comandoEnter + printerParameters.comandoEnter
        }
        if (process.env.NODE_ENV !== 'production') {
            console.log(text)
        } */
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildFooterFiscal = (printerParameters, nota, saleData, paymentNumber, printOnScreen, tapReprintComandas, bonusResume) => {
    let text = ''
    text += printLine(printerParameters)
    if (paymentNumber !== '') {
        text += addLineBreaks(`NSU ${paymentNumber}`, printerParameters)
    }
    text += addLineBreaks('Filial: ' + saleData.subsidiaryCode + ' ' + saleData.subsidiaryName, printerParameters)
    text += addLineBreaks('Loja: ' + saleData.storeCode + ' ' + saleData.storeName, printerParameters)
    text += addLineBreaks('Caixa: ' + saleData.posCode + ' ' + saleData.posName, printerParameters) + printerParameters.comandoEnter

    const CA = CartController.getComandasAgregadas()
    if (CA && CA.length > 0) {
        let comandas = CA.map(c => c.saleDescription).join()
        text += addLineBreaks('Comanda(s): ' + comandas, printerParameters)
    } else if (Util.isTapMode() && tapReprintComandas) {
        text += addLineBreaks('Comanda(s): ' + tapReprintComandas, printerParameters)
    }

    if (saleData.couponFooter) {
        text += centralizeText(saleData.couponFooter, printerParameters)
    }

    // O Totem Gertec já adiciona uma margem grande automaticamente
    if (!Util.isGertecSk210()) {
        text += printerParameters.comandoEnter + printerParameters.comandoEnter
    }
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildPagerId = (printerParameters, saleData) => {
    let text = ''
    text += printLine(printerParameters)
    if (printerParameters.fontExpanded === '' || printerParameters.reset === '') {
        text += centralizeText('SENHA ' + saleData.pagerId, printerParameters) + printerParameters.comandoEnter
        text += printLine(printerParameters)
        return text
    }
    const larguraReal = printerParameters.largura
    const larguraVisual = Math.floor(larguraReal / 2)
    const senha = 'SENHA ' + saleData.pagerId
    // centralização considerando fonte expandida
    const inicio = Math.floor((larguraVisual - senha.length) / 2)
    // linha do texto
    let senhaCentralizada = ' '.repeat(larguraVisual)
    // completa linha inteira pro invertido preencher tudo
    if (printerParameters.inverted === '') {
        senhaCentralizada = printerParameters.fontExpanded + ' '.repeat(inicio) + senha + printerParameters.comandoEnter + printerParameters.reset
    } else {
        senhaCentralizada += ' '.repeat(inicio) + senha
        senhaCentralizada = senhaCentralizada.padEnd(larguraReal, ' ') + ' '.repeat(larguraReal)
        senhaCentralizada = printerParameters.inverted + printerParameters.fontExpanded + senhaCentralizada + printerParameters.reset
    }
    text += senhaCentralizada
    // text += printLine(printerParameters) + printerParameters.comandoEnter
    return text
}
const buildCouponCommands = (printerParameters, saleData, hasToPrintFiscal = true) => {
    const commands = []
    try {
        const cart = (Util.getLocalConfigs('agruparnaimpressao') === true) ? groupCart(CartController.getCart()) : CartController.getCart()
        let currentCommand

        // Header do cupom
        currentCommand = {
            name: 'text',
            parameters: {
                text: buildCouponHeader(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        // Preenche os produtos no cupom
        cart.forEach(product => {
            let isComboProduct = product.productGroups && product.productGroups.length > 0
            let productPrint = product.productPrint

            if (!isComboProduct) {
                // Se for um produto simples, imprime
                let observations = []
                if (product.observations && product.observations.length > 0) {
                    observations = product.observations
                }
                currentCommand = buildProductLine(product.quantity, product.productName, printerParameters, observations)
                commands.push(currentCommand)
            } else if (isComboProduct && productPrint === 'S') {
                // Se for um produto combo e o produto principal é imprime sim
                // Imprime o produto principal
                let observations = []
                if (product.observations && product.observations.length > 0) {
                    observations = product.observations
                }
                currentCommand = buildProductLine(product.quantity, product.productName, printerParameters, observations)
                commands.push(currentCommand)

                // Imprime os filhos que forem imprime sim
                product.productCombo.forEach(childItem => {
                    if (childItem.groupPrint === 'S' || childItem.choosen) {
                        let firstLevelComboPrint = productPrint === 'S'
                        let groupPrint = childItem.groupPrint === 'S'
                        let isFosException = Util.isFosException(childItem, product.productCode, firstLevelComboPrint, groupPrint)

                        if (childItem.groupPrint === 'S' && !isFosException) {
                            let quantity = childItem.quantity ? childItem.quantity : 1
                            let childObservations = []
                            if (childItem.observations && childItem.observations.length > 0) {
                                childObservations = childItem.observations
                            }
                            currentCommand = buildProductLine(quantity, childItem.subItemName, printerParameters, childObservations)
                            commands.push(currentCommand)
                        }

                        // trata os filhos do combo do combo
                        if (childItem.choosen) {
                            let subSubGroups = childItem.choosen
                            let keys = Object.keys(subSubGroups)
                            keys.forEach(key => {
                                let currentGroup = subSubGroups[key]
                                currentGroup.forEach(subSubProd => {
                                    let childPrint = subSubProd.groupPrint === 'S'
                                    // Neste bloco de código o pai só pode ser imprime sim, porque já foi verificado acima.
                                    // Então basta verificar se o filho também é imprime sim
                                    if (childPrint) {
                                        let quantity = subSubProd.quantity ? subSubProd.quantity : 1
                                        let subSubProdObservations = []
                                        if (subSubProd.observations && subSubProd.observations.length > 0) {
                                            subSubProdObservations = subSubProd.observations
                                        }
                                        currentCommand = buildProductLine(quantity, subSubProd.subItemName, printerParameters, subSubProdObservations)
                                        commands.push(currentCommand)
                                    }
                                })
                            })
                        }
                    }
                })
            } else if (isComboProduct && productPrint === 'N') {
                // Se for um produto combo e o produto principal é imprime não.
                // Não imprime o principal e imprime todos os filhos
                // (não importa se os filhos são imprime SIM ou imprime NÃO)
                product.productCombo.forEach(childItem => {
                    let firstLevelComboPrint = productPrint === 'S'
                    let groupPrint = childItem.groupPrint === 'S'
                    let isFosException = Util.isFosException(childItem, product.productCode, firstLevelComboPrint, groupPrint)

                    if (!isFosException) {
                        let quantity = childItem.quantity ? childItem.quantity : 1
                        let childObservations = []
                        if (childItem.observations && childItem.observations.length > 0) {
                            childObservations = childItem.observations
                        }
                        currentCommand = buildProductLine(quantity, childItem.subItemName, printerParameters, childObservations)
                        commands.push(currentCommand)
                    }

                    // trata os filhos do combo do combo
                    if (childItem.choosen) {
                        let subSubGroups = childItem.choosen
                        let keys = Object.keys(subSubGroups)
                        keys.forEach(key => {
                            let currentGroup = subSubGroups[key]
                            currentGroup.forEach(subSubProd => {
                                // Imprime todos os itens filhos de combo do combo, sejam imprime sim ou imprime nao
                                let quantity = subSubProd.quantity ? subSubProd.quantity : 1
                                let subSubProdObservations = []
                                if (subSubProd.observations && subSubProd.observations.length > 0) {
                                    subSubProdObservations = subSubProd.observations
                                }
                                currentCommand = buildProductLine(quantity, subSubProd.subItemName, printerParameters, subSubProdObservations)
                                commands.push(currentCommand)
                            })
                        })
                    }
                })
            }
        })
        // Imprime o pagerId no cupom
        currentCommand = {
            name: 'text',
            parameters: {
                text: buildPagerId(printerParameters, saleData),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
        // Footer do cupom
        currentCommand = {
            name: 'text',
            parameters: {
                text: buildCouponFooter(printerParameters, saleData),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        if (!hasToPrintFiscal && saleData.urlPager) {
            // imprime o qrcode do pager no cupom somente se o cupom discal não for impresso
            currentCommand = {
                name: 'text',
                parameters: {
                    text: buildQrCodePagerDigitalHeader(printerParameters),
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand)

            currentCommand = {
                name: 'qrCode',
                parameters: {
                    text: saleData.urlPager,
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }

            commands.push(currentCommand)

            currentCommand = {
                name: 'text',
                parameters: {
                    text: spaceBeforeCutPaper(printerParameters),
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand)
        }

        // Corta o papel na impressora
        currentCommand = {
            name: 'cutPaper',
            parameters: []
        }

        commands.push(currentCommand)
    } catch (error) {
        console.log(error.message)
    }
    return commands
}

const buildQrCodeCatracaCommands = (printerParameters, qrCodeCat, saleData) => {
    const commands = []

    try {
        let currentCommand

        currentCommand = {
            name: 'text',
            parameters: {
                text: buildQrCodeCatracaHeader(printerParameters, saleData),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'qrCode',
            parameters: {
                text: qrCodeCat,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'text',
            parameters: {
                text: buildQrcodeCatracaFooter(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'text',
            parameters: {
                text: spaceBeforeCutPaper(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'cutPaper',
            parameters: []
        }

        commands.push(currentCommand)
    } catch (error) {
        console.log(error.message)
    }
    return commands
}

const buildQrCodeCatracaHeader = (printerParameters, saleData) => {
    let text = ''
    text += printLine(printerParameters)
    text += addLineBreaks('QrCode para Liberar a Catraca', printerParameters, true)
    text += printLine(printerParameters)
    if (saleData) {
        text += addLineBreaks('Filial: ' + saleData.subsidiaryCode + ' ' + saleData.subsidiaryName, printerParameters, true)
        text += addLineBreaks('Caixa: ' + saleData.posCode, printerParameters, true)
        text += addLineBreaks('Compra realizada em: ' + saleData.dtEmit, printerParameters, true)
    } else {
        text += printerParameters.comandoEnter
    }
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildQrcodeCatracaFooter = (printerParameters) => {
    let text = ''
    text += addLineBreaks('Valido somente para o dia da compra', printerParameters, true)
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildQrCodePagerDigitalHeader = (printerParameters) => {
    let text = ''
    text += printLine(printerParameters)
    text += addLineBreaks('Aponte a camera para acompanhar o seu pedido', printerParameters, true)
    // text += printLine(printerParameters)
    if (!Util.isGertecSk210()) text += printerParameters.comandoEnter
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const spaceBeforeCutPaper = (printerParameters) => {
    return '' + printerParameters.comandoEnter + printerParameters.comandoEnter
}

const buildTestPrinterCommands = (printerParameters) => {
    const commands = []

    let text = ''
    text += printLine(printerParameters)
    text += centralizeText('TESTE DE IMPRESSORA', printerParameters) + printerParameters.comandoEnter
    text += printLine(printerParameters)
    text += addLineBreaks('Teste de impressao executado com sucesso em ' + moment().format('DD/MM/YYYY HH:mm:ss'), printerParameters) + printerParameters.comandoEnter
    text += addLineBreaks('Origem: Terminal de Auto Atendimento', printerParameters, false)
    text += printLine(printerParameters) + printerParameters.comandoEnter + printerParameters.comandoEnter

    commands.push({
        name: 'text',
        parameters: {
            text: text,
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    })

    // adiciona um codigo de barras
    commands.push({
        name: 'barCode',
        parameters: {
            text: '123456789',
            height: 100,
            width: 0,
            position: 0,
            font: 0,
            margin: 25
        }
    })

    // adiciona um qrcode
    commands.push({
        name: 'qrCode',
        parameters: {
            text: 'https://www.teknisa.com/sistema-para-restaurante/',
            height: 100,
            width: 0,
            position: 0,
            font: 0,
            margin: 25
        }
    })

    // Corta o papel na impressora
    let currentCommand = {
        name: 'cutPaper',
        parameters: []
    }
    commands.push(currentCommand)

    return commands
}

const buildProductLine = (quantity, productName, printerParameters, observations = []) => {
    let text = ''
    let productLine = '---> ' + ' ' + quantity + ' ' + productName.toUpperCase() // printerParameters.comandoEnter
    text += addLineBreaks(productLine, printerParameters)

    observations.forEach(obs => {
        if (obs.price && obs.price > 0) {
            let obsName = obs.obsName ? obs.obsName.toUpperCase() : obs.subItemObsName.toUpperCase()
            let obsLine = '---> ' + ' ' + obsName + printerParameters.comandoEnter
            text += addLineBreaks(obsLine, printerParameters)
        }
    })

    text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }

    return {
        name: 'text',
        parameters: {
            text: text,
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
}

const buildFiscalCommands = (printerParameters, nota, protNfe, saleData, paymentMethod, paymentNumber, printOnScreen, tapReprintComandas, bonusResume, balanceFamily, tefData) => {
    const commands = []
    let currentCommand

    // Header da Nota Fiscal
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildFiscalHeader(printerParameters, nota, saleData),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)

    // Preenche os produtos na Nota Fiscal
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildFiscalBody(printerParameters, nota, protNfe, saleData, paymentMethod, balanceFamily),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)

    // Esse bloco só imprime nas notas do tipo SAT
    if (nota.infCFe) {
        let keyNumber = saleData.nfceAccessCode
        if (keyNumber) {
            keyNumber = keyNumber.replace('CFe', '')
        }
        let bigNumber = formatBigNumber(keyNumber)

        // let text = addLineBreaks(bigNumber, printerParameters, true) + printerParameters.comandoEnter
        let text = addLineBreaks(bigNumber, printerParameters, true)
        currentCommand = {
            name: 'text',
            parameters: {
                text: text,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        if (!printOnScreen) {
            let barCode1 = ''
            barCode1 = keyNumber.substring(0, 22)

            let barCode2 = ''
            barCode2 = keyNumber.substring(22, 45)

            currentCommand = {
                name: 'barCode',
                parameters: {
                    text: barCode1,
                    height: 35,
                    width: 0,
                    position: 0,
                    font: 0,
                    margin: 20
                }
            }
            commands.push(currentCommand)

            if (Util.isGertecSk210() || (printerParameters.printerType && printerParameters.printerType === 57)) {
                currentCommand = {
                    name: 'text',
                    parameters: {
                        text: addEmptyLine(printerParameters), // printerParameters.comandoEnter,
                        italic: 0,
                        underlined: 0,
                        expanded: 0,
                        bold: 0,
                        letterType: printerParameters.tipoLetra
                    }
                }
                commands.push(currentCommand)
            }

            currentCommand = {
                name: 'barCode',
                parameters: {
                    text: barCode2,
                    height: 35,
                    width: 0,
                    position: 0,
                    font: 0,
                    margin: 20
                }
            }
            commands.push(currentCommand)

            /* currentCommand = {
                name: 'text',
                parameters: {
                    text: printerParameters.comandoEnter,
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand) */
        }
    }

    if (!printOnScreen) {
        // Gera o QRCode na Nota Fiscal
        currentCommand = {
            name: 'qrCode',
            parameters: {
                text: saleData.qrCode,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
    }

    // Footer da Nota Fiscal
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildFiscalFooter(printerParameters, nota, saleData, paymentNumber, printOnScreen, tapReprintComandas, bonusResume),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }

    commands.push(currentCommand)

    // Footer da Nota Fiscal
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildFooterFiscal(printerParameters, nota, saleData, paymentNumber, printOnScreen, tapReprintComandas, bonusResume),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }

    commands.push(currentCommand)
    // qrcode do pager id
    if (saleData && saleData.urlPager && saleData.urlPager !== '') {
        currentCommand = {
            name: 'text',
            parameters: {
                text: buildQrCodePagerDigitalHeader(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'qrCode',
            parameters: {
                text: saleData.urlPager,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }

        commands.push(currentCommand)

        currentCommand = {
            name: 'text',
            parameters: {
                text: spaceBeforeCutPaper(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        if (!printerParameters.printerType && printerParameters.printerType === 29) {
            currentCommand = {
                name: 'text',
                parameters: {
                    text: spaceBeforeCutPaper(printerParameters),
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand)
            currentCommand = {
                name: 'text',
                parameters: {
                    text: spaceBeforeCutPaper(printerParameters),
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand)
        }
    }

    if (!Util.isGertecSk210()) {
        currentCommand = {
            name: 'text',
            parameters: {
                text: spaceBeforeCutPaper(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
    }

    if (tefData) {
        if (!Util.imprimeTefReduzido()) {
            currentCommand = {
                name: 'cutPaper',
                parameters: []
            }
            commands.push(currentCommand)
        }

        currentCommand = {
            name: 'text',
            parameters: {
                text: buildTefData(tefData, printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
    }

    // Corta o papel na impressora
    currentCommand = {
        name: 'cutPaper',
        parameters: []
    }

    commands.push(currentCommand)

    return commands
}

const buildTefData = function (tefData, printerParameters) {
    let text = printLine(printerParameters)
    text += tefData
    return text
}

const buildNfseCommands = (printerParameters, printData, bonusResume, balanceFamily, tefData) => {
    const commands = []
    let currentCommand

    // Header do Comprovante NFSe
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildNfseHeader(printerParameters, printData),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)

    // Preenche o corpo e os produtos no Comprovante NFSe
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildNfseBody(printerParameters, printData, balanceFamily),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)

    // Gera o QRCode no Comprovante NFSe
    let qrCode = ''
    try {
        qrCode = printData.saleData.nfsePrinting.qrCode
    } catch (error) {
        console.log(error.message)
    }

    if (qrCode !== '') {
        currentCommand = {
            name: 'qrCode',
            parameters: {
                text: qrCode,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
    }

    // Footer do Comprovante NFSe
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildNfseFooter(printerParameters, printData, bonusResume),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)
    if (tefData) {
        if (!Util.imprimeTefReduzido()) {
            currentCommand = {
                name: 'cutPaper',
                parameters: []
            }
            commands.push(currentCommand)
        }
        currentCommand = {
            name: 'text',
            parameters: {
                text: buildTefData(tefData, printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
    }
    // qrcode do pager id
    if (printData && printData.saleData && printData.saleData.urlPager) {
        currentCommand = {
            name: 'text',
            parameters: {
                text: buildQrCodePagerDigitalHeader(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'qrCode',
            parameters: {
                text: printData.saleData.urlPager,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        currentCommand = {
            name: 'text',
            parameters: {
                text: spaceBeforeCutPaper(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)

        if (!printerParameters.printerType && printerParameters.printerType === 29) {
            currentCommand = {
                name: 'text',
                parameters: {
                    text: spaceBeforeCutPaper(printerParameters),
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand)
            currentCommand = {
                name: 'text',
                parameters: {
                    text: spaceBeforeCutPaper(printerParameters),
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            commands.push(currentCommand)
        }
    }

    if (printerParameters.printerType && printerParameters.printerType === 29) {
        currentCommand = {
            name: 'text',
            parameters: {
                text: spaceBeforeCutPaper(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
        currentCommand = {
            name: 'text',
            parameters: {
                text: spaceBeforeCutPaper(printerParameters),
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }
        commands.push(currentCommand)
    }

    // Corta o papel na impressora
    currentCommand = {
        name: 'cutPaper',
        parameters: []
    }

    commands.push(currentCommand)
    return commands
}

const buildNfseHeader = (printerParameters, printData) => {
    let text = ''

    text += addLineBreaks('COMPROVANTE DE VENDA', printerParameters, true)
    text += addLineBreaks('SEM VALOR FISCAL', printerParameters, true)
    text += printLine(printerParameters)

    let headerLines = []
    try {
        let headerText = printData.saleData.nfsePrinting.header
        headerLines = headerText.split('\n')
    } catch (error) {
        console.log(error.message)
    }

    headerLines.forEach(line => {
        text += addLineBreaks(line.trim(), printerParameters, true)
    })

    text += printLine(printerParameters)
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildNfseBody = (printerParameters, printData, balanceFamily) => {
    let text = ''

    let emitDate = 'EMISSÃO ' + moment().format('DD/MM/YYYY HH:mm:ss') + printerParameters.comandoEnter
    text += addLineBreaks(emitDate, printerParameters, true)

    let columnsHeadersStart = 'Serviços'
    const QTDE = 'Qtde'
    const VR_TOTAL = 'Vr. Tot'
    const TOTAIS = 'Totais'
    let columnsHeadersEnd = QTDE + '   ' + VR_TOTAL
    let numberOfBlankSpaces = printerParameters.largura - (columnsHeadersStart.length + columnsHeadersEnd.length)
    let blankSpaces = ''

    for (let i = 0; i < numberOfBlankSpaces; i++) {
        blankSpaces += ' '
    }

    let columnsHeaders = columnsHeadersStart + blankSpaces + columnsHeadersEnd + printerParameters.comandoEnter
    text += columnsHeaders

    let products = []

    try {
        products = printData.saleData.nfsePrinting.products
    } catch (error) {
        console.log(error.message)
    }

    let firstColumnFinalIndex = columnsHeaders.length - (columnsHeadersEnd.length + 3) - 1
    let secondColumnFinalIndex = columnsHeaders.indexOf(QTDE) + QTDE.length
    let thirdColumnFinalIndex = columnsHeaders.indexOf(VR_TOTAL) + VR_TOTAL.length

    let totalQuantity = 0
    let totalValue = 0

    products.forEach(product => {
        let description = product.name
        let quantity = '' + parseFloat(product.quantity)
        let value = Util.formatMoney(product.total).replace('R$', '').trim()

        let firstColumnMaxSize = firstColumnFinalIndex
        if (description.length > firstColumnMaxSize) description = description.substring(0, firstColumnMaxSize)

        totalQuantity = Math.round((parseFloat(totalQuantity) + parseFloat(product.quantity)) * 100) / 100
        totalValue = Math.round((parseFloat(totalValue) + parseFloat(product.total)) * 100) / 100

        let filler1BlankSpaces = secondColumnFinalIndex - description.length - quantity.length
        let filler2BlankSpaces = thirdColumnFinalIndex - value.length - secondColumnFinalIndex
        let betweenColumnsFiller1 = ''
        let betweenColumnsFiller2 = ''

        for (let i = 0; i < filler1BlankSpaces; i++) {
            betweenColumnsFiller1 += ' '
        }

        for (let i = 0; i < filler2BlankSpaces; i++) {
            betweenColumnsFiller2 += ' '
        }

        text += description + betweenColumnsFiller1 + quantity + betweenColumnsFiller2 + value + printerParameters.comandoEnter
    })

    let formattedTotalValue = Util.formatMoney(totalValue).replace('R$', '').trim()
    let startLineBlankSpaces = firstColumnFinalIndex - TOTAIS.length
    let filler3BlankSpaces = secondColumnFinalIndex - startLineBlankSpaces - TOTAIS.length - ('' + totalQuantity).length
    let filler4BlankSpaces = thirdColumnFinalIndex - formattedTotalValue.length - secondColumnFinalIndex
    let startLineFiller = ''
    let betweenColumnsFiller3 = ''
    let betweenColumnsFiller4 = ''

    for (let i = 0; i < startLineBlankSpaces; i++) {
        startLineFiller += ' '
    }

    for (let i = 0; i < filler3BlankSpaces; i++) {
        betweenColumnsFiller3 += ' '
    }

    for (let i = 0; i < filler4BlankSpaces; i++) {
        betweenColumnsFiller4 += ' '
    }

    let totalLine = startLineFiller + TOTAIS + betweenColumnsFiller3 + totalQuantity + betweenColumnsFiller4 + formattedTotalValue
    text += printerParameters.comandoEnter + totalLine + printerParameters.comandoEnter
    text += printLine(printerParameters)

    let totalCampaignCashbackDiscount = CashbackCampaingController.getDiscountApplied()
    if (totalCampaignCashbackDiscount.value) {
        let formattedTotalDiscount = formatFloat(totalCampaignCashbackDiscount.value)
        let totalValueWithDiscount = Math.round((parseFloat(totalValue) - parseFloat(totalCampaignCashbackDiscount.value)) * 100) / 100
        if (totalCampaignCashbackDiscount.campaignEnabled === 1) {
            text += justifyText('DESCONTO CRM&BONUS R$ ', formattedTotalDiscount, printerParameters)
        } else {
            text += justifyText('DESCONTOS R$ ', formattedTotalDiscount, printerParameters)
        }
        text += justifyText('VALOR PAGO R$ ', formatFloat(totalValueWithDiscount), printerParameters)
        text += printLine(printerParameters)
    }

    let consumerLines = []
    try {
        let consumerText = printData.saleData.nfsePrinting.consumer
        consumerLines = consumerText.split('\n')
    } catch (error) {
        console.log(error.message)
    }

    if (consumerLines != null && consumerLines.length > 0) {
        text += addLineBreaks(consumerLines[0].trim(), printerParameters, true)
    }

    consumerLines.forEach((line, index) => {
        if (index > 0) text += addLineBreaks(line.trim(), printerParameters)
    })

    text += printLine(printerParameters)

    let qrCodeUrlLines = []
    try {
        let qrCodeUrlText = printData.saleData.nfsePrinting.qrCodeUrl
        qrCodeUrlLines = qrCodeUrlText.split('\n')
    } catch (error) {
        console.log(error.message)
    }

    qrCodeUrlLines.forEach(line => {
        text += addLineBreaks(line.trim(), printerParameters, true)
    })

    const paymentID = (printData && printData.paymentMethod && printData.paymentMethod.IDTIPORECE) || ''
    if (IdentifiedConsumerController.userIsLogged() && ['9', 'A'].includes(paymentID)) {
        const consumerData = IdentifiedConsumerController.getConsumerData()
        let saldoCons = printData.saleData.consumerDebit || 0
        let saldoCred = printData.saleData.personalCredit || 0

        text += justifyText('CLIENTE: ', consumerData.clientCode + ' - ' + consumerData.clientName, printerParameters)
        text += justifyText('CONSUMIDOR: ', consumerData.consumerCode, printerParameters)
        text += justifyText('NOME: ', consumerData.consumerName, printerParameters)

        if (paymentID === 'A') {
            formatFloat(saldoCons)
            // saldoCons = Util.formatMoney(saldoCons)
            saldoCons = formatFloat(saldoCons)
            text += justifyText('SALDO TOTAL: R$', saldoCons, printerParameters)
        }
        if (paymentID === '9') {
            if (balanceFamily && balanceFamily.length > 0) {
                balanceFamily.forEach(e => {
                    let balance = e.balance ? formatFloat(e.balance) : formatFloat(0)
                    text += justifyText('SALDO FAMILIA R$ ' + e.familyName + ': ', balance, printerParameters)
                })
            } else {
                // saldoCred = Util.formatMoney(saldoCred)
                saldoCred = formatFloat(saldoCred)
                text += justifyText('SALDO TOTAL: R$ ', saldoCred, printerParameters)
            }
        }
    }

    text += printerParameters.comandoEnter
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildNfseFooter = (printerParameters, printData, bonusResume) => {
    let text = ''

    text += printerParameters.comandoEnter
    let footerLines = []

    try {
        let footerText = printData.saleData.nfsePrinting.footer
        footerLines = footerText.split('\n')
    } catch (error) {
        console.log(error.message)
    }

    footerLines.forEach(line => {
        text += addLineBreaks(line.trim(), printerParameters)
    })

    text += printerParameters.comandoEnter

    if (bonusResume && bonusResume.totalBalance && bonusResume.campaignEnabled === 1) {
        text += printLine(printerParameters)
        let formattedBalance = formatFloat(bonusResume.totalBalance)
        text += addLineBreaks('SALDO ATUALIZADO CRM&BONUS: R$ ' + formattedBalance, printerParameters) + printerParameters.comandoEnter
    }
    if (bonusResume && bonusResume.totalBalance && bonusResume.campaignEnabled === 2) {
        text += printLine(printerParameters)
        let formattedBalance = formatFloat(bonusResume.totalBalance)
        let formattedGeneretedBalance = formatFloat(bonusResume.generatedBalance)
        let formattedUsedBonus = formatFloat(bonusResume.redeemBalance)
        let formatedDataBonus = bonusResume.expiration
        if (formattedUsedBonus) {
            text += addLineBreaks(`VOCE USOU: R$ ${formattedUsedBonus} DE CASHBACK`, printerParameters)
        }
        if (formattedGeneretedBalance) {
            text += addLineBreaks('VOCE GANHOU: R$ ' + formattedGeneretedBalance + ' VALIDO ATE ' + formatedDataBonus, printerParameters)
        }
        if (formattedBalance) {
            text += addLineBreaks('SALDO TOTAL DE CASHBACK: R$ ' + formattedBalance, printerParameters)
        }
        text += addLineBreaks('PREENCHA A PESQUISA E GANHE UM PREMIO NA PROXIMA COMPRA', printerParameters) + printerParameters.comandoEnter
    }
    if (bonusResume && bonusResume.totalBalance && bonusResume.campaignEnabled === 3) {
        text += printLine(printerParameters)
        let formattedBalance = formatFloat(bonusResume.totalBalance)
        text += addLineBreaks('SALDO TOTAL DE CASHBACK: R$ ' + formattedBalance, printerParameters) + printerParameters.comandoEnter
    }
    if (printData.saleData && printData.saleData.couponFooter) {
        text += centralizeText(printData.saleData.couponFooter, printerParameters)
    }
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

/**
 * Insere em cada produto do carrinho o código das impressoras de produção (impressoras de cozinha) parametrizadas para
 * aquele produto e retorna um array contendo todas as impressoras de produção que serão utilizadas para imprimir este
 * pedido na cozinha
 */
/* const handleKitchenPrinters = (cart, productsPrinters) => {
    let kitchenPrinters = []

    cart.forEach(product => {
        // Trata das impressoras de produção (impressoras da cozinha) do produto pai
        let thisProdPrinters = productsPrinters.find(element => element.productCode === product.productCode)
        if (thisProdPrinters !== undefined) {
            product.seqPrinterProduct = thisProdPrinters.seqPrinterProduct
            product.seqPrinterProduct2 = thisProdPrinters.seqPrinterProduct2
            product.seqPrinterPuxa = thisProdPrinters.seqPrinterPuxa
            if (!kitchenPrinters.includes(product.seqPrinterProduct) && product.seqPrinterProduct !== null) {
                kitchenPrinters.push(product.seqPrinterProduct)
            }
            if (!kitchenPrinters.includes(product.seqPrinterProduct2) && product.seqPrinterProduct2 !== null) {
                kitchenPrinters.push(product.seqPrinterProduct2)
            }
            if (!kitchenPrinters.includes(product.seqPrinterPuxa) && product.seqPrinterPuxa !== null) {
                kitchenPrinters.push(product.seqPrinterPuxa)
            }
        }

        // Trata das impressoras de produção (impressoras da cozinha) dos produtos filhos, se houver
        if (product.productGroups.length > 0) {
            product.productCombo.forEach(childItem => {
                let thisChildProdPrinters = productsPrinters.find(element => element.productCode === childItem.subItemCode)
                if (thisChildProdPrinters !== undefined) {
                    childItem.seqPrinterProduct = thisChildProdPrinters.seqPrinterProduct
                    childItem.seqPrinterProduct2 = thisChildProdPrinters.seqPrinterProduct2
                    childItem.seqPrinterPuxa = thisChildProdPrinters.seqPrinterPuxa
                    if (!kitchenPrinters.includes(childItem.seqPrinterProduct) && childItem.seqPrinterProduct !== null) {
                        kitchenPrinters.push(childItem.seqPrinterProduct)
                    }
                    if (!kitchenPrinters.includes(childItem.seqPrinterProduct2) && childItem.seqPrinterProduct2 !== null) {
                        kitchenPrinters.push(childItem.seqPrinterProduct2)
                    }
                    if (!kitchenPrinters.includes(childItem.seqPrinterPuxa) && childItem.seqPrinterPuxa !== null) {
                        kitchenPrinters.push(childItem.seqPrinterPuxa)
                    }
                }
            })
        }
    })

    return kitchenPrinters
} */

const buildCancelCommands = (printerParameters, cancelProof, cancelSaleResponse, nfceCode) => {
    const commands = []
    let text = ''
    cancelProof = cancelProof || ''

    text += printLine(printerParameters)
    text += addLineBreaks('CANCELAMENTO DE VENDA', printerParameters, true)
    text += printLine(printerParameters)

    let cancelProofFormatted = cancelProof.replace(/\n/g, printerParameters.comandoEnter)

    commands.push(newTextCommand(text, printerParameters))
    commands.push(newTextCommand(cancelProofFormatted, printerParameters))
    commands.push(cutPaperCommand())

    return commands
}

const newTextCommand = (text, printerParameters) => {
    return {
        name: 'text',
        parameters: {
            text: text,
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
}

const cutPaperCommand = () => {
    return {
        name: 'cutPaper',
        parameters: []
    }
}

const printQrCodeCatraca = (printData) => {
    return printData && printData.saleData && printData.saleData.qrCodeCat && printData.saleData.qrCodeCat !== ''
}

const buildCounterTokens = (counter, length, printerParameters) => {
    let text = ''
    text += centralizeText(counter + ' DE ' + length, printerParameters, true)
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildTokensFooter = (printerParameters, saleData) => {
    let text = ''
    let senha = saleData.pagerId ? saleData.pagerId : ''
    text += printLine(printerParameters)

    if (senha !== '') {
        text += centralizeText('SENHA ' + senha, printerParameters) + printerParameters.comandoEnter
        text += printLine(printerParameters)
    }
    if (process.env.NODE_ENV !== 'production') {
        console.log(text)
    }
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

const buildTokensCommands = (printerParameters, saleData, product, counter, length) => {
    const commands = []
    let currentCommand

    // contador de fichas
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildCounterTokens(counter, length, printerParameters),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)

    currentCommand = {
        name: 'text',
        parameters: {
            text: buildCouponHeader(printerParameters),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)
    // Preenche os produtos no cupom
    let isComboProduct = product.productGroups && product.productGroups.length > 0
    let productPrint = product.productPrint

    if (!isComboProduct) {
        // Se for um produto simples, imprime
        let observations = []
        if (product.observations && product.observations.length > 0) {
            observations = product.observations
        }
        currentCommand = buildProductLine(product.quantity, product.productName, printerParameters, observations)
        commands.push(currentCommand)
    } else if (isComboProduct && productPrint === 'S') {
        // Se for um produto combo e o produto principal é imprime sim
        // Imprime o produto principal
        let observations = []
        if (product.observations && product.observations.length > 0) {
            observations = product.observations
        }
        currentCommand = buildProductLine(product.quantity, product.productName, printerParameters, observations)
        commands.push(currentCommand)

        // Imprime os filhos que forem imprime sim
        product.productCombo.forEach(childItem => {
            if (childItem.groupPrint === 'S' || childItem.choosen) {
                let firstLevelComboPrint = productPrint === 'S'
                let groupPrint = childItem.groupPrint === 'S'
                let isFosException = Util.isFosException(childItem, product.productCode, firstLevelComboPrint, groupPrint)

                if (childItem.groupPrint === 'S' && !isFosException) {
                    let quantity = childItem.quantity ? childItem.quantity : 1
                    let childObservations = []
                    if (childItem.observations && childItem.observations.length > 0) {
                        childObservations = childItem.observations
                    }
                    currentCommand = buildProductLine(quantity, childItem.subItemName, printerParameters, childObservations)
                    commands.push(currentCommand)
                }

                // trata os filhos do combo do combo
                if (childItem.choosen) {
                    let subSubGroups = childItem.choosen
                    let keys = Object.keys(subSubGroups)
                    keys.forEach(key => {
                        let currentGroup = subSubGroups[key]
                        currentGroup.forEach(subSubProd => {
                            let childPrint = subSubProd.groupPrint === 'S'
                            // Neste bloco de código o pai só pode ser imprime sim, porque já foi verificado acima.
                            // Então basta verificar se o filho também é imprime sim
                            if (childPrint) {
                                let quantity = subSubProd.quantity ? subSubProd.quantity : 1
                                let subSubProdObservations = []
                                if (subSubProd.observations && subSubProd.observations.length > 0) {
                                    subSubProdObservations = subSubProd.observations
                                }
                                currentCommand = buildProductLine(quantity, subSubProd.subItemName, printerParameters, subSubProdObservations)
                                commands.push(currentCommand)
                            }
                        })
                    })
                }
            }
        })
    } else if (isComboProduct && productPrint === 'N') {
        // Se for um produto combo e o produto principal é imprime não.
        // Não imprime o principal e imprime todos os filhos
        // (não importa se os filhos são imprime SIM ou imprime NÃO)
        product.productCombo.forEach(childItem => {
            let firstLevelComboPrint = productPrint === 'S'
            let groupPrint = childItem.groupPrint === 'S'
            let isFosException = Util.isFosException(childItem, product.productCode, firstLevelComboPrint, groupPrint)

            if (!isFosException) {
                let quantity = childItem.quantity ? childItem.quantity : 1
                let childObservations = []
                if (childItem.observations && childItem.observations.length > 0) {
                    childObservations = childItem.observations
                }
                currentCommand = buildProductLine(quantity, childItem.subItemName, printerParameters, childObservations)
                commands.push(currentCommand)
            }

            // trata os filhos do combo do combo
            if (childItem.choosen) {
                let subSubGroups = childItem.choosen
                let keys = Object.keys(subSubGroups)
                keys.forEach(key => {
                    let currentGroup = subSubGroups[key]
                    currentGroup.forEach(subSubProd => {
                        // Imprime todos os itens filhos de combo do combo, sejam imprime sim ou imprime nao
                        let quantity = subSubProd.quantity ? subSubProd.quantity : 1
                        let subSubProdObservations = []
                        if (subSubProd.observations && subSubProd.observations.length > 0) {
                            subSubProdObservations = subSubProd.observations
                        }
                        currentCommand = buildProductLine(quantity, subSubProd.subItemName, printerParameters, subSubProdObservations)
                        commands.push(currentCommand)
                    })
                })
            }
        })
    }
    // Footer da ficha
    currentCommand = {
        name: 'text',
        parameters: {
            text: buildTokensFooter(printerParameters, saleData),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand)

    /* currentCommand = {
        name: 'text',
        parameters: {
            text: spaceBeforeCutPaper(printerParameters),
            italic: 0,
            underlined: 0,
            expanded: 0,
            bold: 0,
            letterType: printerParameters.tipoLetra
        }
    }
    commands.push(currentCommand) */

    currentCommand = {
        name: 'cutPaper',
        parameters: []
    }
    commands.push(currentCommand)

    return commands
}

function groupCart (cart) {
    let groupedCart = []
    let visitedIndexes = new Set()

    cart.forEach((product, index) => {
        if (visitedIndexes.has(index)) return // já foi agrupado

        let isComboProduct = product.productGroups && product.productGroups.length > 0
        if (isComboProduct) {
            groupedCart.push(product)
        } else {
            // agrupa produtos iguais
            let quantity = (product.quantity || 1)

            for (let i = index + 1; i < cart.length; i++) {
                let other = cart[i]
                if (
                    !visitedIndexes.has(i) &&
                    other.productCode === product.productCode &&
                    JSON.stringify(other.observations) === JSON.stringify(product.observations)
                ) {
                    quantity += (other && other.quantity) || 1
                    visitedIndexes.add(i)
                }
            }

            let groupedProduct = {
                ...product,
                quantity: quantity
            }

            groupedCart.push(groupedProduct)
        }

        visitedIndexes.add(index)
    })

    return groupedCart
}

export default {
    simplePrint: async function (text, chaveAcesso = null, qrcode = null, rodape = null) {
        text = text || ''
        let printerInfo = getPrinterInfo()
        let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
        let currentCommand = {}

        let printerText = text.replace(/\n/g, printerParameters.comandoEnter)
        let printerCommands = [{
            name: 'text',
            parameters: {
                text: printerText,
                italic: 0,
                underlined: 0,
                expanded: 0,
                bold: 0,
                letterType: printerParameters.tipoLetra
            }
        }]

        if (chaveAcesso) {
            let keyNumber = chaveAcesso
            if (keyNumber) {
                keyNumber = keyNumber.replace('CFe', '')
            }
            let barCode1 = ''
            barCode1 = keyNumber.substring(0, 22)

            let barCode2 = ''
            barCode2 = keyNumber.substring(22, 45)
            let bigNumber = formatBigNumber(keyNumber)

            let barCodeNumber = addLineBreaks(bigNumber, printerParameters, true) + printerParameters.comandoEnter

            currentCommand = {
                name: 'text',
                parameters: {
                    text: barCodeNumber,
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            printerCommands.push(currentCommand)

            currentCommand = {
                name: 'barCode',
                parameters: {
                    text: barCode1,
                    height: 40,
                    width: 0,
                    position: 0,
                    font: 0,
                    margin: 25
                }
            }
            printerCommands.push(currentCommand)

            currentCommand = {
                name: 'text',
                parameters: {
                    text: ' ' + printerParameters.comandoEnter,
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }

            printerCommands.push(currentCommand)

            currentCommand = {
                name: 'barCode',
                parameters: {
                    text: barCode2,
                    height: 40,
                    width: 0,
                    position: 0,
                    font: 0,
                    margin: 25
                }
            }
            printerCommands.push(currentCommand)
        }
        if (qrcode) {
            currentCommand = {
                name: 'qrCode',
                parameters: {
                    text: qrcode,
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            printerCommands.push(currentCommand)
        }
        if (rodape) {
            printerText = rodape.replace(/\n/g, printerParameters.comandoEnter)
            currentCommand = {
                name: 'text',
                parameters: {
                    text: rodape,
                    italic: 0,
                    underlined: 0,
                    expanded: 0,
                    bold: 0,
                    letterType: printerParameters.tipoLetra
                }
            }
            printerCommands.push(currentCommand)
        }

        // Corta o papel na impressora
        currentCommand = {
            name: 'cutPaper',
            parameters: []
        }
        printerCommands.push(currentCommand)

        return await requesModule.curlRequest(
            EVENT_PRINT,
            {
                printerInfo: printerInfo,
                commands: printerCommands
            },
            Util.getLocalConfigs('urlPerifericos')
        ).then(r => r)
    },

    relatorioFechamentoDodia: async function (shouldPrint = true, lastClosing = false) {
        let params = { ...Util.getGeneralInfo() }
        params.usesOpeningLock = lastClosing ? 'S' : 'N'
        let fechamento = await requesModule.postRequest('pos/close', params, 'parent', (2 * 60 * 1000)).then(r => r && r.data)

        if (fechamento.closing.error) {
            Util.showErrorNotification(fechamento.closing.message)
        } else if (shouldPrint) {
            let message = lastClosing ? LocaleController.getString('ultimo_fechamento_dia_sucesso')
                : LocaleController.getString('fechamento_caixa_sucesso')
            Util.showInfoModal(message)
            this.simplePrint(fechamento.closing.data.dia)
        }

        let blockCaixa = fechamento && fechamento.closing && !fechamento.closing.error && fechamento.closing.data &&
            fechamento.closing.data.dataAbertura && fechamento.closing.data.ultimoFechamento === 'S'
        if (blockCaixa) {
            Util.setLocalVar('blockedForDate', fechamento.closing.data.dataAbertura)
        }
    },

    // Imprime folha de teste da impressora
    testPrinter: async function (testPrinterInfo, testURLPerifericos) {
        try {
            let printerParameters = PrinterParameters.getPrinterParameters(testPrinterInfo.printerType)
            let printerCommands = buildTestPrinterCommands(printerParameters)
            let result = await sendPrint(testPrinterInfo, printerCommands, testURLPerifericos)
            return result
        } catch (error) {
            return {
                error: true,
                message: error.message
            }
        }
    },

    printCoupons: async function (printData, userChooseNotPrint, sendByEmail, email, router) {
        let printCouponConfig = Util.getLocalConfigs('imprimeEspelho')
        let printTokensConfig = Util.getLocalConfigs('impFichas')
        let removeConfirmImpressaoCupom = Util.getLocalConfigs('removeConfirmImpressaoCupom')
        const allowNotPrint = Util.getLocalConfigs('allowNotPrint')
        // let hasToPrintCoupon = (printCouponConfig && ((!userChooseNotPrint && allowNotPrint) || !userChooseNotPrint)) || (userChooseNotPrint && !allowNotPrint)
        // let hasToPrintCoupon = (userChooseNotPrint && !allowNotPrint) || (printCouponConfig && !userChooseNotPrint)
        let hasToPrintCoupon = (printCouponConfig && !userChooseNotPrint) || (userChooseNotPrint && !allowNotPrint && printCouponConfig)
        let hasToPrintFiscal = !userChooseNotPrint
        let printCouponResult = null
        let printTokensResult = null
        let printFiscalResult = null
        let result = true
        let qrCodeCat = printQrCodeCatraca(printData) ? printData.saleData.qrCodeCat : ''

        if (sendByEmail) {
            // Chamar a lógica que vai fazer o envio da nota por e-mail
            let sendEmailResult = await this.sendFiscalByEmail(printData.saleData, email)
            if (!sendEmailResult || (sendEmailResult && sendEmailResult.error)) {
                // caso ocorra alguma falha imprimir o cupom fiscal
                let message = 'Não foi possível inserir o e-mail para envio do cupom fiscal. <br> O cupom fiscal será impresso.'
                console.log(message + ' Erro:' + sendEmailResult.message)
                Util.showInfoModal(message)
                hasToPrintFiscal = true
            }
        }
        if (hasToPrintCoupon && !Util.isTapMode() && !printTokensConfig) {
            printCouponResult = await this.printCoupon(printData.saleData, hasToPrintFiscal)
            if (!printCouponResult || (printCouponResult && printCouponResult.data && printCouponResult.data.error) || (printCouponResult && printCouponResult.error)) {
                console.log('Falha na impressora. Não foi possível imprimir o cupom do cliente.')
                result = false
                Util.showErrorScreen(router, 'printerError')
                return result
            }
        }

        if (hasToPrintFiscal || removeConfirmImpressaoCupom) {
            let printBalanceFamily = Util.printBalance() === '1' && printData && printData.paymentMethod && printData.paymentMethod.IDTIPORECE === '9'
            let balanceFamily = null
            if (printBalanceFamily) {
            // aciona a rota de login novamente pra pegar o saldo das familias atualizado
                const consumerData = IdentifiedConsumerController.getConsumerData()
                let requestObject = {
                    consumerId: consumerData.consumerLogin,
                    password: '',
                    subsidiaryCode: Util.getGeneralInfo()['subsidiaryCode'],
                    storeCode: Util.getGeneralInfo()['storeCode'],
                    lockKeyboardCons: 'S'
                }
                let loginResponse = await requesModule.postRequest('consumer/login', requestObject).then(res => res || {}).catch((e) => {})
                balanceFamily = (loginResponse && loginResponse.data && loginResponse.data.consumer &&
                            loginResponse.data.consumer.personalCredit && loginResponse.data.consumer.personalCredit.familyBalances) || null
            }

            if (printData.saleData.isNFSe) {
                printFiscalResult = await this.printNfse(printData, balanceFamily, printData.tefData)
            } else {
                printFiscalResult = await this.printFiscal(printData.xml, printData.saleData, printData.paymentMethod, printData.paymentNumber, false, '', balanceFamily, printData.tefData)
            }

            if (!printFiscalResult || (printFiscalResult && printFiscalResult.data && printFiscalResult.data.error) || (printFiscalResult && printFiscalResult.error)) {
                console.log('Falha na impressora. Não foi possível imprimir o cupom do cliente.')
                result = false
                Util.showErrorScreen(router, 'printerError')
                return result
            }
        }
        if (qrCodeCat && qrCodeCat.length > 0) {
            qrCodeCat.forEach(async e => {
                let printQrCodeCatracaResult = await this.printQrCodeCatraca(e, printData.saleData)
                if (!printQrCodeCatracaResult || (printQrCodeCatracaResult && printQrCodeCatracaResult.data && printQrCodeCatracaResult.data.error) ||
                    (printQrCodeCatracaResult && printQrCodeCatracaResult.error)) {
                    console.log('Falha na impressora. Não foi possível imprimir o cupom do cliente.')
                    Util.showErrorScreen(router, 'printerError')
                    return false
                }
            })
            /* let printQrCodeCatracaResult = await this.printQrCodeCatraca(qrCodeCat)
            if (!printQrCodeCatracaResult || (printQrCodeCatracaResult && printQrCodeCatracaResult.data && printQrCodeCatracaResult.data.error)
                || (printQrCodeCatracaResult && printQrCodeCatracaResult.error)) {
                console.log('Falha na impressora. Não foi possível imprimir o cupom do cliente.')
                result = false
                Util.showErrorScreen(router, 'printerError')
                return result
            } */
        }

        if (printTokensConfig) {
            printTokensResult = await this.printTokens(printData.saleData)
            if (!printTokensResult || (printTokensResult && printTokensResult.data && printTokensResult.data.error) || (printTokensResult && printTokensResult.error)) {
                console.log('Falha na impressora. Não foi possível imprimir as fichas de produtos do cliente.')
                result = false
                Util.showErrorScreen(router, 'printerError')
                return result
            }
        }

        return result
    },

    // Imprime o cupom simples do consumidor com o pedido e numero da senha
    printCoupon: async function (saleData, hasToPrintFiscal = true) {
        let printerInfo = getPrinterInfo()
        let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
        let printerCommands = buildCouponCommands(printerParameters, saleData, hasToPrintFiscal)
        return await sendPrint(printerInfo, printerCommands)
    },

    printQrCodeCatraca: async function (qrCodeCat, saleData) {
        let printerInfo = getPrinterInfo()
        let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
        let printerCommands = buildQrCodeCatracaCommands(printerParameters, qrCodeCat, saleData)
        return await sendPrint(printerInfo, printerCommands)
    },

    // Imprime o Documento Auxiliar da Nota Fiscal Eletronica
    printFiscal: async function (fiscalXML, saleData, paymentMethod, paymentNumber, printOnScreen = false, tapReprintComandas = '', balanceFamily = null, tefData = '') {
        // fiscalXML = Util.getXMLSatMock()
        let externalLibs = require('./../../assets/externalLibs/x2js')
        let x2js = new externalLibs.X2JS()
        let jsonFiscal = x2js.xml_str2json(fiscalXML)

        // Contem as informacoes da nota fiscal propriamente dita
        let nota = ''
        // Contem as informacoes do protocolo da nota fiscal
        let protNfe = ''
        // Se a nota fiscal foi gerada em contingencia, o XML nao traz os dados de protocolo da nota
        try {
            // Nota NFe recebida completa
            nota = jsonFiscal.nfeProc.NFe
            protNfe = jsonFiscal.nfeProc.protNFe
        } catch (error) {
            // Nota NFe recebida em contingência
            nota = jsonFiscal.NFe
        }

        if (!nota) {
            try {
                // Nota de tipo SAT
                nota = jsonFiscal.CFe
            } catch (error) {
                console.log('Houve um problema com o formato da nota fiscal recebida')
            }
        }
        let printerInfo = getPrinterInfo()
        let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
        let cashbackCampaignStatus = await CashbackCampaingController.getStatus(true)
        let bonusResume = null
        if (cashbackCampaignStatus.status) {
            bonusResume = await CashbackCampaingController.getResume()
        }
        let printerCommands = buildFiscalCommands(printerParameters, nota, protNfe, saleData, paymentMethod, paymentNumber, printOnScreen, tapReprintComandas, bonusResume, balanceFamily, tefData)

        if (printOnScreen) {
            return buildPrintOnScreenText(printerCommands, printerParameters)
        } else {
            return await sendPrint(printerInfo, printerCommands)
        }
    },

    // Imprime o comprovante da NFSe para o consumidor (somente no DF e se o cliente parametrizou para utilizar esse modo)
    printNfse: async function (printData, balanceFamily = null) {
        let printerInfo = getPrinterInfo()
        let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)

        let cashbackCampaignStatus = await CashbackCampaingController.getStatus()
        let bonusResume = null
        if (cashbackCampaignStatus.status) {
            bonusResume = await CashbackCampaingController.getResume()
        }

        let printerCommands = buildNfseCommands(printerParameters, printData, bonusResume, balanceFamily, printData.tefData)
        return await sendPrint(printerInfo, printerCommands)
    },

    printTokens: async function (saleData) {
        let printerInfo = getPrinterInfo()
        let cart = CartController.getCart()
        let counter = 1
        cart.forEach(async (product) => {
            const prodToPrint = { ...product }
            for (let i = 0; i < product.quantity; i++) {
                prodToPrint.quantity = 1
                let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
                let printerCommands = buildTokensCommands(printerParameters, saleData, prodToPrint, counter, cart.length)
                counter++
                await sendPrint(printerInfo, printerCommands)
            }
        })
        return true
    },

    // Adiciona o e-mail na venda para que o cupom seja enviado por e-mail
    sendFiscalByEmail: async function (saleData, rawEmail) {
        let sendEmailResult = await requesModule.postRequest(
            'sale/sendingDanfeByEmail', {
                'subsidiaryCode': saleData.subsidiaryCode,
                'posCode': saleData.posCode,
                'saleSeq': saleData.saleSeq,
                'nfceCode': saleData.nfceCode,
                'email': rawEmail
            })
            .then(r => r)
            .catch((e) => {
                return {
                    error: true,
                    message: (e && e.message) || 'Erro ao inserir e-mail na venda'
                }
            })
        return sendEmailResult
    },

    // Imprime o Comprovante de cancelamento de TEF / Nota Fiscal
    printCancel: async function (cancelProof, cancelSaleResponse, nfceCode) {
        let printerInfo = getPrinterInfo()
        let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
        let printerCommands = buildCancelCommands(printerParameters, cancelProof, cancelSaleResponse, nfceCode)
        return await sendPrint(printerInfo, printerCommands)
    },

    printCancelFiscal: async function (dadosImpressao, chaveAcesso = null, qrcode = null, rodape = null) {
        return await this.simplePrint(dadosImpressao, chaveAcesso, qrcode, rodape)
    }

    // Imprime os cupons de produtos nas impressoras de produção respectivas
    /* sendKitchenPrints: async function () {
        let cart = CartController.getCart()
        // let storePrinters = PrintersBySector.getStorePrinters()
        let productsPrinters = PrintersBySector.getProductsPrinters()
        let kitchenPrinters = handleKitchenPrinters(cart, productsPrinters)

        kitchenPrinters.forEach(async (printer) => {
            let printerInfo = getPrinterInfo() // Tem que ser ajustado para cada tipo de impressora (ainda não existe endpoint que traga o MODELO da impressora)
            let printerParameters = PrinterParameters.getPrinterParameters(printerInfo.printerType)
            let printerCommands = buildKitchenCommands(printerParameters, printer, cart)
            await sendPrint(printerInfo, printerCommands) // Ainda estamos mandando para a impressora padrao e nao para a impressora da cozinha selecionada
            // Tratar os erros, como é feito com as outras chamadas de impressão dentro de SaleController (porém, tratar aqui, porque serão várias iterações para tratar)
        })
    } */
}



// WEBPACK FOOTER //
// ./src/assets/controllers/PrinterController.js